$(document).ready(function() {
  var metafield = $('.t4s-tab-wrapper').data('id-symbol-fmp') || "";
  var param;  
  if (metafield.trim() !== "") {param = metafield;} 
  else {param = document.URL.split("products/")[1].split("?")[0].toUpperCase();}  
    $.getJSON('https://financialmodelingprep.com/api/v3/cash-flow-statement/'+param+'?period=quarter&limit=4&apikey=3ccf620ce9315de8a4996e601373f716', function(data){
      
          
      var Stat_operatingCashFlow_calc = 0;
      var Stat_capitalExpenditure_calc = 0;
      var Stat_freeCashFlow_calc = 0;
      

      $.each(data, function(i, elem){

         Stat_operatingCashFlow_calc = Stat_operatingCashFlow_calc + elem.operatingCashFlow;
         Stat_capitalExpenditure_calc = Stat_capitalExpenditure_calc + elem.capitalExpenditure;
         Stat_freeCashFlow_calc = Stat_freeCashFlow_calc + elem.freeCashFlow;
        

      });


      var Stat_operatingCashFlow = nFormatter(Stat_operatingCashFlow_calc, 2);
      $('#stat_operating_cash_flow').append(Stat_operatingCashFlow);
      $('#stat_operating_cash_flow2').append(Stat_operatingCashFlow);
      
      var Stat_capitalExpenditure = nFormatter(Stat_capitalExpenditure_calc, 2);
      $('#stat_capital_expenditures').append(Stat_capitalExpenditure);      
      $('#stat_capital_expenditures2').append(Stat_capitalExpenditure);      
      
      var Stat_freeCashFlow = nFormatter(Stat_freeCashFlow_calc, 2);
      $('#stat_free_cash_flow').append(Stat_freeCashFlow);      
      $('#stat_free_cash_flow2').append(Stat_freeCashFlow);            
        
    })
});
